import { render, staticRenderFns } from "./newForumDialog.vue?vue&type=template&id=0e368ec5&"
import script from "./newForumDialog.vue?vue&type=script&lang=js&"
export * from "./newForumDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e368ec5')) {
      api.createRecord('0e368ec5', component.options)
    } else {
      api.reload('0e368ec5', component.options)
    }
    module.hot.accept("./newForumDialog.vue?vue&type=template&id=0e368ec5&", function () {
      api.rerender('0e368ec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/components/newForumDialog.vue"
export default component.exports